import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { useCampaignMessagesAPI } from "../campaigns.api";
import { Accordion, AccordionDetails, AccordionSummary, Box, Card, CardContent, CardHeader, Collapse, IconButton, List, ListItem, ListItemText, ListSubheader, Typography } from "@mui/material";
import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";
import { Replay, ReplayOutlined } from "@mui/icons-material";
import { useState } from "react";
import { minutesInHour } from "date-fns";

type Props = {
  campaignId: string | undefined;
};

export default function CampaignMessagesList({ campaignId }: Props) {
  const notNewCampaign = campaignId && campaignId !== "new";
  const [loading, setLoading] = useState(notNewCampaign);
  const onDataRefresh = () => setLoading(false);
  const { data: messages, isLoading: isCampaignMessagesLoading, refetch } = useCampaignMessagesAPI(campaignId, onDataRefresh);
  const dataRefresh = () => {
    if (!notNewCampaign) return;
    setLoading(true);
    refetch();
  };

  const messagesList = (
    <List>
      <ListSubheader sx={styles.row}>
        <Typography sx={styles.nameItem} variant="subtitle2">Name</Typography>
        <Box sx={styles.counters}>
          <Typography sx={styles.item} variant="subtitle2">Delivered</Typography>
          <Typography sx={styles.item} variant="subtitle2">Pending</Typography>
          <Typography sx={styles.item} variant="subtitle2">Scheduled</Typography>
          <Typography sx={styles.lastItem} variant="subtitle2">Failed</Typography>
        </Box>
      </ListSubheader>

      {messages?.map((messageData) => (
        <ListItem divider sx={styles.listItem} key={messageData.fanId}>
          <Typography variant="subtitle2" sx={styles.nameItem}>{messageData.name}</Typography>
          <Box sx={styles.counters}>
            <Typography sx={styles.item} variant="subtitle2">{messageData.delivered}</Typography>
            <Typography sx={styles.item} variant="subtitle2">{messageData.pending}</Typography>
            <Typography sx={styles.item} variant="subtitle2">{messageData.scheduled}</Typography>
            <Typography sx={styles.lastItem} variant="subtitle2">{messageData.failed}</Typography>
          </Box>
        </ListItem>
      ))}
    </List>
  );

  return (
    <Card sx={styles.card}>
      <CardHeader
        title="Messages"
        action={
          <IconButton
            onClick={dataRefresh}
            disabled={loading || isCampaignMessagesLoading}
          >
          <ReplayOutlined />
        </IconButton>}
      />
      <SpinnerWrapper loading={loading || isCampaignMessagesLoading}>
        <CardContent>
          {
            !messages || messages.length === 0
              ? 'No messages sent or scheduled yet.'
              : messagesList
          }
        </CardContent>
      </SpinnerWrapper>
    </Card>
  );
};

const styles = {
  card: {
    marginTop: '20px',
    minHeight: '200px'
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
  },
  counters: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
  },
  item: {
    width: '100px',
    textAlign: 'center',
  },
  nameItem: {
    width: '200px',
    textAlign: 'left',
  },
  lastItem: {
    width: '50px',
    textAlign: 'center',
  }
};